import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_4 = { class: "card mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_play_list = _resolveComponent("play-list")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.playlist)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, [
              _createTextVNode(_toDisplayString(_ctx.playlist.data.name), 1),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.playlist.data.description), 1)
            ]),
            (!_ctx.userOwns)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args))),
                  class: "btn btn-primary"
                }, "Copy to My Playlists"))
              : (_openBlock(), _createElementBlock("small", _hoisted_3, "You Own This Playlist"))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_play_list, {
              public: "",
              playlist: _ctx.playlist
            }, null, 8, ["playlist"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}